import DispatchesList from "./DispatchesList";

export default {
    list: DispatchesList,
};
